module.exports = {"513336100":"香巴拉镇","513336101":"青德镇","513336103":"热打镇","513336201":"沙贡乡","513336202":"水洼乡","513336205":"然乌乡","513336206":"洞松乡","513336208":"定波乡","513336209":"正斗乡","513336210":"白依乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513336.json
// module id = 2558
// module chunks = 0